var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Other Settings")]),
    _vm._v(" "),
    _c(
      "form",
      [
        _c("div", { staticClass: "row row-clear-md-8" }, [
          _c("div", { staticClass: "col-md-5" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateCompletedBookingsDefaultDateRange,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(
                    "Default date range for completed bookings on select stars"
                  ),
                ]),
                _vm._v(" "),
                _c("flatpickr", {
                  ref: "date",
                  staticClass: "form-control",
                  attrs: {
                    config: _vm.flatPickerDateConfig,
                    name: "completed_bookings_default_date_range",
                  },
                  model: {
                    value: _vm.$v.stateCompletedBookingsDefaultDateRange.$model,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.$v.stateCompletedBookingsDefaultDateRange,
                        "$model",
                        $$v
                      )
                    },
                    expression:
                      "$v.stateCompletedBookingsDefaultDateRange.$model",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Date range",
                    field: _vm.$v.stateCompletedBookingsDefaultDateRange,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-success",
            attrs: { click: _vm.handleSaveCallback },
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _vm._v(" Save Changes\n    "),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }